// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.PaymentIframeModal_payment-modal__backdrop__PMfHW {
  background-color: rgba(0, 0, 0, 0.45) !important;
  backdrop-filter: blur(4px);
}
.PaymentIframeModal_payment-modal__summary-card__aaeUq {
  background-color: #f8f9f8;
  border: 1px solid #e2e7e3;
  border-radius: 16px;
  padding: 24px;
}
.PaymentIframeModal_payment-modal__summary-card__aaeUq h4 {
  margin: 0 0 20px 0;
  font-size: 16px;
  font-weight: 700;
  color: #1a241f;
}
.PaymentIframeModal_payment-modal__summary-list__JWllU {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.PaymentIframeModal_payment-modal__summary-row__7f7sd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-size: 14px;
}
.PaymentIframeModal_payment-modal__summary-row__7f7sd span {
  color: #707f75;
  font-weight: 500;
}
.PaymentIframeModal_payment-modal__summary-row__7f7sd strong {
  font-size: 12px;
  color: #1a241f;
  font-weight: 700;
  text-align: right;
  max-width: 60%;
}
.PaymentIframeModal_payment-modal__summary-row--total__an97h {
  align-items: center;
  margin-top: 4px;
}
.PaymentIframeModal_payment-modal__summary-row--total__an97h span {
  color: #1a241f;
  font-size: 12px;
  font-weight: 700;
}
.PaymentIframeModal_payment-modal__summary-row--total__an97h strong {
  font-size: 12px;
  font-weight: 800;
}
.PaymentIframeModal_payment-modal__summary-divider__2yW2A {
  border: none;
  border-top: 1px solid #e2e7e3;
  margin: 4px 0;
}
.PaymentIframeModal_payment-modal__content__4R3-g {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 95vw;
  max-width: 950px;
  height: 85vh;
  background-color: #EFF0EC;
  border-radius: 32px;
  box-shadow: 0 18px 48px rgba(18, 34, 29, 0.04);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  outline: none;
}
.PaymentIframeModal_payment-modal__header__xKn73 {
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(16, 25, 21, 0.08);
  background-color: #F7F5F1;
}
.PaymentIframeModal_payment-modal__header__xKn73 div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.PaymentIframeModal_payment-modal__header__xKn73 p {
  margin: 0;
  color: #5F726B;
  font-size: 14px;
}
.PaymentIframeModal_payment-modal__title__FK5jN {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #13231D;
}
.PaymentIframeModal_payment-modal__close-button__S4TD7 {
  background: none;
  border: none;
  cursor: pointer;
  color: #5F726B;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 50%;
  transition: background-color 0.3s;
}
.PaymentIframeModal_payment-modal__close-button__S4TD7:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: #13231D;
}
.PaymentIframeModal_payment-modal__close-button__S4TD7 svg {
  width: 24px;
  height: 24px;
}
.PaymentIframeModal_payment-modal__body__FKtG8 {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  background-color: #fff;
}
@media (max-width: 768px) {
  .PaymentIframeModal_payment-modal__body__FKtG8 {
    flex-direction: column;
    overflow-y: auto;
  }
}
.PaymentIframeModal_payment-modal__iframe-wrapper__0ZYVF {
  flex: 1 1;
  position: relative;
  height: 100%;
  min-height: 400px;
  background-color: #fff;
}
@media (max-width: 768px) {
  .PaymentIframeModal_payment-modal__iframe-wrapper__0ZYVF {
    min-height: 450px;
  }
}
.PaymentIframeModal_payment-modal__iframe__oA5yQ {
  width: 100%;
  height: 100%;
  border: none;
}
.PaymentIframeModal_payment-modal__loader__rpGGo {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #F7F5F1;
  z-index: 10;
}
.PaymentIframeModal_payment-modal__summary__kz1Lr {
  width: 320px;
  background-color: #F7F5F1;
  padding: 24px;
  border-left: 1px solid rgba(16, 25, 21, 0.08);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
}
@media (max-width: 768px) {
  .PaymentIframeModal_payment-modal__summary__kz1Lr {
    width: 100%;
    border-left: none;
    border-top: 1px solid rgba(16, 25, 21, 0.08);
  }
}
.PaymentIframeModal_payment-modal__summary__kz1Lr h4 {
  margin: 0 0 20px 0;
  font-size: 16px;
  font-weight: 600;
  color: #13231D;
}
.PaymentIframeModal_payment-modal__summary-list__JWllU {
  display: flex;
  flex-direction: column;
  gap: 0px;
}
.PaymentIframeModal_payment-modal__summary-row__7f7sd {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  border-bottom: 1px solid rgba(93, 114, 133, 0.2);
  padding-bottom: 10px;
}
.PaymentIframeModal_payment-modal__summary-row__7f7sd span {
  color: #5F726B;
}
.PaymentIframeModal_payment-modal__summary-row__7f7sd strong {
  color: #13231D;
  font-weight: 600;
}
.PaymentIframeModal_payment-modal__summary-row--total__an97h {
  font-size: 16px;
  margin-top: 8px;
}
.PaymentIframeModal_payment-modal__summary-row--total__an97h span {
  color: #13231D;
  font-weight: 500;
}
.PaymentIframeModal_payment-modal__summary-row--total__an97h strong {
  font-size: 12px;
  color: #13231D;
}
.PaymentIframeModal_payment-modal__summary-divider__2yW2A {
  border: none;
  border-top: 1px solid rgba(16, 25, 21, 0.08);
  margin: 0;
}
.PaymentIframeModal_payment-modal__summary-secure__HIYb\\+ {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  color: #5F726B;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 15px;
  font-weight: 400;
}
.PaymentIframeModal_payment-modal__summary-secure__HIYb\\+ svg {
  width: 20px;
  height: 20px;
  fill: currentColor;
  flex-shrink: 0;
  margin-top: 2px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/ui/PaymentIframeModal/PaymentIframeModal.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAbE;EACE,gDAAA;EACA,0BAAA;AAgBJ;AAbE;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;AAeJ;AAbI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAeN;AAXE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAaJ;AAVE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;AAYJ;AAVI;EACE,cAAA;EACA,gBAAA;AAYN;AATI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAWN;AARI;EACE,mBAAA;EACA,eAAA;AAUN;AARM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAUR;AAPM;EACE,eAAA;EACA,gBAAA;AASR;AAJE;EACE,YAAA;EACA,6BAAA;EACA,aAAA;AAMJ;AAHE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,yBD5DmB;EC6DnB,mBDSS;ECRT,8CDaS;ECZT,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;AAKJ;AAFE;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,+CAAA;EACA,yBD1EmB;AC8EvB;AAFI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAIN;AADI;EACE,SAAA;EACA,cD9EiB;EC+EjB,eDjEc;ACoEpB;AACE;EACE,SAAA;EACA,eD1EgB;EC2EhB,gBAAA;EACA,cDxFmB;ACyFvB;AAEE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cD9FmB;EC+FnB,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YDjEO;ECkEP,kBAAA;EACA,iCAAA;AAAJ;AAEI;EACE,qCAAA;EACA,cDzGiB;ACyGvB;AAGI;EACE,WAAA;EACA,YAAA;AADN;AAKE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AAHJ;AAKI;EAPF;IAQI,sBAAA;IACA,gBAAA;EAFJ;AACF;AAME;EACE,SAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;AAJJ;AAMI;EAPF;IAQI,iBAAA;EAHJ;AACF;AAME;EACE,WAAA;EACA,YAAA;EACA,YAAA;AAJJ;AAOE;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBD7JmB;EC8JnB,WAAA;AALJ;AAQE;EACE,YAAA;EACA,yBDnKmB;ECoKnB,aD1HO;EC2HP,6CAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,SD/HO;ACyHX;AAQI;EAVF;IAWI,WAAA;IACA,iBAAA;IACA,4CAAA;EALJ;AACF;AAOI;EACE,kBAAA;EACA,eDhKc;ECiKd,gBAAA;EACA,cDhLiB;AC2KvB;AAQI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AANN;AASI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eD9Kc;EC+Kd,gDAAA;EACA,oBAAA;AAPN;AASM;EACE,cDjMe;AC0LvB;AAUM;EACE,cDtMe;ECuMf,gBAAA;AARR;AAWM;EACE,eD7LY;EC8LZ,eD1KG;ACiKX;AAWQ;EACE,cD/Ma;ECgNb,gBAAA;AATV;AAYQ;EACE,eAAA;EACA,cDrNa;AC2MvB;AAeI;EACE,YAAA;EACA,4CAAA;EACA,SAAA;AAbN;AAgBI;EACE,aAAA;EACA,SD/LK;ECgML,uBAAA;EACA,cDnOiB;ECoOjB,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAdN;AAgBM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAdR","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import \"../../../assets/styles/_variables.scss\";\n\n.payment-modal {\n  &__backdrop {\n    background-color: rgba(0, 0, 0, 0.45) !important;\n    backdrop-filter: blur(4px);\n  }\n\n  &__summary-card {\n    background-color: #f8f9f8;\n    border: 1px solid #e2e7e3;\n    border-radius: 16px;\n    padding: 24px;\n\n    h4 {\n      margin: 0 0 20px 0;\n      font-size: 16px;\n      font-weight: 700;\n      color: #1a241f;\n    }\n  }\n\n  &__summary-list {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  &__summary-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    font-size: 14px;\n\n    span {\n      color: #707f75;\n      font-weight: 500;\n    }\n\n    strong {\n      font-size: 12px;\n      color: #1a241f;\n      font-weight: 700;\n      text-align: right;\n      max-width: 60%;\n    }\n\n    &--total {\n      align-items: center;\n      margin-top: 4px;\n\n      span {\n        color: #1a241f;\n        font-size: 12px;\n        font-weight: 700;\n      }\n\n      strong {\n        font-size: 12px;\n        font-weight: 800;\n      }\n    }\n  }\n\n  &__summary-divider {\n    border: none;\n    border-top: 1px solid #e2e7e3;\n    margin: 4px 0;\n  }\n\n  &__content {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 95vw;\n    max-width: 950px;\n    height: 85vh;\n    background-color: $color-bg;\n    border-radius: $radius-card;\n    box-shadow: $shadow-soft;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    outline: none;\n  }\n\n  &__header {\n    padding: $space-16 $space-24;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid $color-border;\n    background-color: $color-surface;\n\n    div {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n    }\n\n    p {\n      margin: 0;\n      color: $text-muted;\n      font-size: $font-size-small;\n    }\n  }\n\n  &__title {\n    margin: 0;\n    font-size: $font-size-h3;\n    font-weight: 600;\n    color: $text-main;\n  }\n\n  &__close-button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: $text-muted;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: $space-8;\n    border-radius: 50%;\n    transition: background-color $transition-speed;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.05);\n      color: $text-main;\n    }\n\n    svg {\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n  &__body {\n    flex: 1;\n    display: flex;\n    flex-direction: row; // Divide en 2 columnas por defecto\n    overflow: hidden;\n    background-color: #fff;\n\n    @media (max-width: $breakpoint-md) {\n      flex-direction: column; // En móviles se apilan una sobre otra\n      overflow-y: auto;\n    }\n  }\n\n  // Contenedor seguro para el iframe\n  &__iframe-wrapper {\n    flex: 1;\n    position: relative;\n    height: 100%;\n    min-height: 400px;\n    background-color: #fff;\n\n    @media (max-width: $breakpoint-md) {\n      min-height: 450px;\n    }\n  }\n\n  &__iframe {\n    width: 100%;\n    height: 100%;\n    border: none;\n  }\n\n  &__loader {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: $color-surface;\n    z-index: 10;\n  }\n\n  &__summary {\n    width: 320px;\n    background-color: $color-surface;\n    padding: $space-24;\n    border-left: 1px solid $color-border;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: $space-24;\n\n    @media (max-width: $breakpoint-md) {\n      width: 100%;\n      border-left: none;\n      border-top: 1px solid $color-border;\n    }\n\n    h4 {\n      margin: 0 0 20px 0;\n      font-size: $font-size-body;\n      font-weight: 600;\n      color: $text-main;\n    }\n\n    &-list {\n      display: flex;\n      flex-direction: column;\n      gap: 0px;\n    }\n\n    &-row {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      font-size: $font-size-small;\n      border-bottom: 1px solid rgba(93, 114, 133, 0.2);\n      padding-bottom: 10px;\n\n      span {\n        color: $text-muted;\n      }\n\n      strong {\n        color: $text-main;\n        font-weight: 600;\n      }\n\n      &--total {\n        font-size: $font-size-body;\n        margin-top: $space-8;\n\n        span {\n          color: $text-main;\n          font-weight: 500;\n        }\n\n        strong {\n          font-size: 12px;\n          color: $text-main;\n        }\n      }\n    }\n\n    &-divider {\n      border: none;\n      border-top: 1px solid $color-border;\n      margin: 0;\n    }\n\n    &-secure {\n      display: flex;\n      gap: $space-12;\n      align-items: flex-start;\n      color: $text-muted;\n      font-size: 12px;\n      line-height: 1.4;\n      margin-top: 15px;\n      font-weight: 400;\n\n      svg {\n        width: 20px;\n        height: 20px;\n        fill: currentColor;\n        flex-shrink: 0;\n        margin-top: 2px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"payment-modal__backdrop": `PaymentIframeModal_payment-modal__backdrop__PMfHW`,
	"payment-modal__summary-card": `PaymentIframeModal_payment-modal__summary-card__aaeUq`,
	"payment-modal__summary-list": `PaymentIframeModal_payment-modal__summary-list__JWllU`,
	"payment-modal__summary-row": `PaymentIframeModal_payment-modal__summary-row__7f7sd`,
	"payment-modal__summary-row--total": `PaymentIframeModal_payment-modal__summary-row--total__an97h`,
	"payment-modal__summary-divider": `PaymentIframeModal_payment-modal__summary-divider__2yW2A`,
	"payment-modal__content": `PaymentIframeModal_payment-modal__content__4R3-g`,
	"payment-modal__header": `PaymentIframeModal_payment-modal__header__xKn73`,
	"payment-modal__title": `PaymentIframeModal_payment-modal__title__FK5jN`,
	"payment-modal__close-button": `PaymentIframeModal_payment-modal__close-button__S4TD7`,
	"payment-modal__body": `PaymentIframeModal_payment-modal__body__FKtG8`,
	"payment-modal__iframe-wrapper": `PaymentIframeModal_payment-modal__iframe-wrapper__0ZYVF`,
	"payment-modal__iframe": `PaymentIframeModal_payment-modal__iframe__oA5yQ`,
	"payment-modal__loader": `PaymentIframeModal_payment-modal__loader__rpGGo`,
	"payment-modal__summary": `PaymentIframeModal_payment-modal__summary__kz1Lr`,
	"payment-modal__summary-secure": `PaymentIframeModal_payment-modal__summary-secure__HIYb+`
};
export default ___CSS_LOADER_EXPORT___;
